import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://stg-api.bulletscout.com",
  headers: {
    "x-api-key": process.env.REACT_APP_X_API_KEY || "QKAsMnJrNC1vsPwWwBs4cg5VMWBhmc32iq97Yj7a",
  },
});


export default apiClient;
